


var numberTag = '[object Number]';


var objectProto = Object.prototype;


var objectToString = objectProto.toString;


function isObjectLike(value) {
  return !!value && typeof value == 'object';
}


function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && objectToString.call(value) == numberTag);
}

module.exports = isNumber;



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash.isnumber/index.js
// module id = 1165
// module chunks = 0